// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label_86c4b1fd {
  display: block;
  font-weight: 600;
}
.label_label_86c4b1fd {
  margin-bottom: 0.167rem;
}
.label_text_86c4b1fd {
  margin-bottom: 0;
  display: inline;
}
.label_ellipsis_86c4b1fd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label_ellipsis_86c4b1fd:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.label_ellipsis_86c4b1fd:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.label_ellipsis_86c4b1fd .label__item_86c4b1fd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label_ellipsis_86c4b1fd .label__item_86c4b1fd:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.label_ellipsis_86c4b1fd .label__item_86c4b1fd:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_86c4b1fd`,
	"label_label": `label_label_86c4b1fd`,
	"label_text": `label_text_86c4b1fd`,
	"label_ellipsis": `label_ellipsis_86c4b1fd`,
	"label__item": `label__item_86c4b1fd`
};
export default ___CSS_LOADER_EXPORT___;
